import React from 'react';
import PatternGalleries from './PatternGalleries';
import { connect } from 'react-redux';

import { getMessage } from '../../reducers/i18n';
import { getCurrentSearchValue } from '../../reducers/ui.sitesearch';
import { getGalleryData } from '../../reducers/patterns';

const SearchResult = props => (
    <PatternGalleries {...props} />
    );

const mapStateToProps = state => {
    const title = getMessage(state, 'SEARCH_GALLERY_TITLE');
    const currentSearch = getCurrentSearchValue(state);
    const galleryData = getGalleryData(state);
    const { totalHits, patterns, items } = galleryData;
    console.log({galleryState: galleryData, currentSearch});
    return {
        title: `${totalHits} ${title} ${currentSearch.toUpperCase()}`,
        patterns,
        items,
        totalHits,
    };
};

export default connect(mapStateToProps)(SearchResult);



// WEBPACK FOOTER //
// ./src/components/patterngalleries/SearchResult.js